module.exports = __webpack_public_path__ + "static/media/UpcomingTransactionsRounded.d792db79.png";